/*****
 * Created by Allan on 2022/08/05.
 * Contact 84880528@qq.com.
 * *****/
import Vue from 'vue'
import { Base64 } from 'js-base64'
import getQueryVariable from '@/repayment/services/getQueryVariable'
import store from '@/repayment/store/'
import {errHandler, successHandler} from "./config"
import axios from 'axios'
import Qs from 'qs'
axios.defaults.baseURL = '/api/';

let appId=Base64.decode(getQueryVariable("a"));
/*if(window.location.hash.split('?')[1]===undefined){
    appId='';
}else{
    appId=Base64.decode(getQueryVariable("a"));
}*/

let token;
if(JSON.stringify(store.state.user.user)!=='{}'){
    token=store.state.user.user.token;
}else{
    token='';
}
axios.defaults.headers.common['appId'] = appId;
axios.defaults.headers.common['token'] =token;
/****
 * @param url         字符串，请求地址
 * @param method      字符串，请求类型，默认为 get 请求
 * @param params      是即将与请求一起发送的 URL 参数，必须是一个无格式对象(plain object)或 URLSearchParams 对象
 * @param data        是作为请求主体被发送的数据，只适用于这些请求方法 'PUT', 'POST', 和 'PATCH'
 * @param headers     是即将被发送的自定义请求头  {'X-Requested-With': 'XMLHttpRequest'}
 * @return Promise    返回 resolve 和 reject 状态的 Promise对象
 * *****/

export default (url, {method = 'get', params = null, data = null, headers = {},reqType='form'} = {},urlPar='') => {
    let currLoca=localStorage.getItem('locale');
    let locale=currLoca==='enIn'?'en-IN':(currLoca==='es'?'es-ES':'en-US');
    let contentType='application/x-www-form-urlencoded';
    if(reqType==='json'){
        contentType='application/json'
    }else if (reqType==='file') {
        contentType='multipart/form-data'
    }else{
        data=Qs.stringify(data);
    }
    headers['Content-Type']=contentType+';charset=utf-8';
    return axios({
        method: method,
        url:url+'?t='+new Date().getTime()+'&language='+locale+urlPar,
        data:data,
        params:params,
        headers:headers,
        //withCredentials:true,   //表示跨域请求时是否需要使用凭证
        timeout:60000    //设置超时时间
    }).then(successHandler).catch(errHandler)
};



// WEBPACK FOOTER //
// ./src/repayment/services/http/index.js